
  import { CopyIcon } from 'vue-feather-icons'
  import { copyToClipBoard } from '~/fc/helpers'

  export default {
    name: "ButtonCopy",
    components: {
      CopyIcon
    },
    props: ['btnText', 'copyText', 'copyMsg', 'outlined', 'iconOnly'],
    data: () => ({
      text: '',
      copied: false
    }),
    mounted () {
      this.text = this.btnText || this.$t('copy')
    },
    methods: {
      onClick () {
        this.copied = true
        this.text = this.copyMsg || (this.$t('copied') + '!')
        copyToClipBoard(this.copyText)

        setTimeout(() => {
          this.text = this.btnText || this.$t('copy')
          this.copied = false
        }, 1000)
      }
    }
  }
